import { WAddress } from "@/types/address";
import { DictItem, DictLike, DictLikeNumberKey } from "@/types/dict";
import { Org } from "@/types/org";
import { ProductCategory } from "@/types/product";
import { createContext } from "react";

interface DictContextType {
  creditLevels: Array<DictLike>;
  currencys: Array<DictLike>;
  orgs: Array<Org>;
  saleTypes: Array<DictItem>;
  salePayMethod: Array<DictItem>;
  saleTradeTerm: Array<DictItem>;
  saleShippingMethod: Array<DictItem>;
  saleOrderTypes: Array<DictLike>;
  saleCustomerType: Array<DictItem>;
  purchaseTradeTerm: Array<DictItem>;
  purchasePayMethod: Array<DictItem>;
  purchaseOrderTypes: Array<DictLike>;
  address: Array<DictItem>;
  rootCategories: Array<ProductCategory>;
  exchangeRate: Array<DictItem>,
  printSetting: Array<DictItem>,
  addressData: Array<WAddress>,
  brandData: Array<DictItem>,
  purchaseRule: Array<DictItem>,
  productType: Array<DictItem>,
  locationTypes: Array<DictLikeNumberKey>;
  shipStatus: Array<DictLikeNumberKey>;
  shipMethods: Array<DictLikeNumberKey>;
  shipLogistics: Array<DictLikeNumberKey>;
  shipEvents: Array<DictLikeNumberKey>;
  packageTypes: Array<DictLike>;

  setSaleTypes: (info: Array<DictItem>) => void;
  setSaleTradeTerm: (info: Array<DictItem>) => void;
  setSalePayMethod: (info: Array<DictItem>) => void;
  setSaleShippingMethod: (info: Array<DictItem>) => void;
  setSaleCustomerType: (info: Array<DictItem>) => void;
  setPurchaseTradeTerm: (info: Array<DictItem>) => void;
  setPurchasePayMethod: (info: Array<DictItem>) => void;
  setAddress: (info: Array<DictItem>) => void;
  setExchangeRate: (info: Array<DictItem>) => void;
  setPrintSetting: (info: Array<DictItem>) => void;
  setAddressData: (info: Array<WAddress>) => void;
  setBrandData: (info: Array<DictItem>) => void;
  setPurchaseRule: (info: Array<DictItem>) => void;
  setProductType: (info: Array<DictItem>) => void;
}

const defaultContextValue: DictContextType = {
  creditLevels: [],
  rootCategories: [],
  orgs: [],
  currencys: [],
  saleTypes: [],
  saleTradeTerm: [],
  salePayMethod: [],
  saleShippingMethod: [],
  saleOrderTypes: [],
  saleCustomerType: [],
  purchaseTradeTerm: [],
  purchasePayMethod: [],
  address: [],
  purchaseOrderTypes: [],
  exchangeRate: [],
  printSetting: [],
  addressData: [],
  brandData: [],
  purchaseRule: [],
  productType: [],
  locationTypes: [],
  shipStatus: [],
  shipMethods: [],
  shipLogistics: [],
  shipEvents: [],
  packageTypes: [],
  setSaleTypes: () => { },
  setSaleTradeTerm: () => { },
  setSalePayMethod: () => { },
  setSaleShippingMethod: () => { },
  setSaleCustomerType: () => { },
  setPurchaseTradeTerm: () => { },
  setPurchasePayMethod: () => { },
  setAddress: () => { },
  setExchangeRate: () => { },
  setPrintSetting: () => { },
  setAddressData: () => { },
  setBrandData: () => { },
  setPurchaseRule: () => { },
  setProductType: () => { },
};

export const DictContext = createContext(defaultContextValue);
